import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import ViewUI from 'view-design';
import Vuex from 'vuex';
import axios from '@utils/api';
import VueAxios from 'vue-axios';
import global from '@utils/global' //全局方法
import VueBus from 'vue-bus';  //bus
import uploader from 'vue-simple-uploader'
import Clipboard from 'vue-clipboard2'

import { VTree, VSelectTree} from 'vue-tree-halower';
import VueCropper from 'vue-cropperjs';
import 'cropperjs/dist/cropper.css';
import VideoPlayer from 'vue-video-player'
import 'vue-video-player/src/custom-theme.css'
import 'video.js/dist/video-js.css'

// 引入插件
import validation from "jquery-validation";
import $ from 'jquery';
import "view-design/dist/styles/iview.css";
import "@directive/index";
import '@assets/css/paas/paas-common.css';
import "@assets/css/img/png16.css";
import "@assets/iconfont/iconfont.css";
import 'vue-tree-halower/dist/halower-tree.min.css'
import 'cropperjs/dist/cropper.css';
import VueSweetalert2 from './plugins/vue-sweetalert2';

Vue.use(ViewUI);
Vue.use(Vuex);
Vue.use(VueAxios,axios);
Vue.use(global);
Vue.use(VueBus);
Vue.use(VTree,VSelectTree);
Vue.use(validation);
Vue.component(VueCropper);
Vue.use(uploader);
// 使用插件
Vue.use(VueSweetalert2);
Vue.use(VideoPlayer);
Vue.use(Clipboard);

Vue.config.productionTip = false;

import { initEnumDatas } from "@api/admin.js";
new Vue({
  router,
  store,
  created: function() {
      let me = this;
      initEnumDatas().then(res => {
      if(res.code === 200) {
          console.log("更新enum数据");
          me.$store.commit('initEnums', res.data);
          // me.$Message.info("1")
          window.localStorage.setItem("enums", JSON.stringify(res.data));
         // me.$Message.info("2")
      }
    }).catch(err => {
        me.$Message.error('系统数据初始化，请重试！'+err);
    })
  },
  render: h => h(App)
}).$mount("#app");
